<app-base-modal
  [title]="'Загрузка Excel'"
>
  @if (isLoading) {
    <app-loader/>
  }
  <div class="content">
    <mat-form-field appearance="outline">
      <mat-label>Аккаунт WB</mat-label>
      <mat-select [(ngModel)]="account">
        @for (option of wbAccounts; track $index) {
          <mat-option [value]="option.account">
            {{ option.account }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <app-delayed-file-upload-card
      [allowedExtensions]="excelExtensions"
      [multiple]="false"
      (filesSelectedForUpload)="filesSelectedForUpload($event)"
    />
  </div>
  <div class="buttons-container">
    <button
      mat-button
      color="primary"
      (click)="handleUploadExcel()"
    >
      Сохранить
    </button>
    <button
      mat-button
      color="warn"
      (click)="closeDialog('cancel')"
    >
      Отменить
    </button>
  </div>
</app-base-modal>
